import mutations from './mutations'
import actions from './actions'
import getters from'./getters'
export default {
    state: {
        quickAccesses: [],
        quickAccessesPages: 0,
        currentQuickAccess: {},
        newQuickAccess: {
            title: '',
            imageUrl: '',
            link: ''
        }
    },
    mutations,
    actions,
    getters
}
